import PropTypes from "prop-types";

import { t } from "../../../../services";
import { strCode } from "../../../../consts";

import { Paragraph2, RadioOptionsSelector, WrapperContainer } from "../../../../components";

import { ChooseActionStepWrapper } from "./styled";

const ChooseActionStep = ({ selectedOptionId, actionOptions, onOptionSelect }) => {
  return (
    <ChooseActionStepWrapper>
      <WrapperContainer mb={16}>
        <Paragraph2>{t(strCode.CHOOSE_ACTION_TITLE)}:</Paragraph2>
      </WrapperContainer>

      <RadioOptionsSelector
        name="certificate-action-selector"
        selectedId={selectedOptionId}
        options={actionOptions}
        onChange={onOptionSelect}
      />
    </ChooseActionStepWrapper>
  );
};

ChooseActionStep.propTypes = {
  actionOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      Component: PropTypes.node.isRequired
    })
  ).isRequired,
  selectedOptionId: PropTypes.string.isRequired,
  onOptionSelect: PropTypes.func.isRequired
};

export default ChooseActionStep;
